import {CanActivateFn} from '@angular/router';
import {HupSubscriptionsService} from "../../data/services/hup-subscriptions.service";
import {inject} from "@angular/core";
import {OnlinePaymentChecker} from "../components/utils/online-payment-checker";
import {NavigationCommand, NavigationService} from "../../data/services/navigation.service";
import {ConfigService} from "../services/config.service";

export const EditSubscriptionActionGuard: CanActivateFn = (route, state) => {
  const subscriptionService = inject(HupSubscriptionsService);
  const onlinePaymentChecker: OnlinePaymentChecker = new OnlinePaymentChecker();
  const navigationService = inject(NavigationService);
  const configService = inject(ConfigService);

  const webSubId = route.paramMap.get('subWebId');
  const subBackendId = route.paramMap.get('subBackendId');
  const targetUrl = route.parent.url.at(0).path === 'sub-change' ? NavigationCommand.SUBCHANGE : NavigationCommand.PAYMENT;

  if (webSubId && subBackendId) {
    configService.loadConfig(onlinePaymentChecker.ONLINE_PAYMENT_METHOD_ID_CONFIG_KEY).subscribe(
      (_config) => {
        if (_config && _config.value) {
          onlinePaymentChecker.setPaymentCode(_config.value);
          subscriptionService.getSubscription(webSubId, subBackendId).subscribe(
            ($subscription) => {
              if ($subscription && onlinePaymentChecker.isOnlinePayment($subscription.curPayment)) {
                navigationService.navigateTo(targetUrl);
                return false;
              }
            });
        }
      }
    );
  }
  return true;
};
